export const CHECKUPS_ENDPOINT_KEY = 'checkups'
export const CHECKUP_LOGS_ENDPOINT_KEY = 'checkup-logs'
